import {
  SegmentedRadioButton,
} from "@simplecitizen/gdl-react-ui-components";

import { useAppDispatch, useAppSelector } from "src/hooks/redux-hooks";
import { clearIdDocs } from "src/store/slices/identityDocCapture";
import { clearNonIdDocs } from "src/store/slices/uploadedNonIdDocsSlice";

interface EUCitizenShipProps {
  selectedEUCitizenShip: "eu_citizen" | "not_eu_citizen" | null;
  setSelectedEUCitizenShip: React.Dispatch<
    React.SetStateAction<"eu_citizen" | "not_eu_citizen" | null>
  >;
  setSelectedStatusType: React.Dispatch<
    React.SetStateAction<StatusType | null>
  >;
  setSelectedCategory: React.Dispatch<
    React.SetStateAction<StatusCategory | null>
  >;
  resetStates?: () => void;
}

const EUCitizenShip = ({
  selectedEUCitizenShip,
  setSelectedEUCitizenShip,
  resetStates,
}: EUCitizenShipProps) => {
  const dispatch = useAppDispatch();
  const client = useAppSelector(
    (state) => state.questionnaire_data.questionnaire?.client
  );
  const jurisdiction = useAppSelector(
    (state) => state.questionnaire_data.questionnaire?.jurisdiction
  );

  const isSwitzerland =
    jurisdiction?.code2?.toUpperCase() === "CH" ||
    jurisdiction?.code3?.toUpperCase() === "CHE" ||
    jurisdiction?.name?.toUpperCase() === "SWITZERLAND";

  return (
    <div>
      <div className="w-full mt-4">
        <div className="mt-3">
          <div className="font-semibold">
            {isSwitzerland
              ? "Are you an EU/EFTA Citizen?"
              : "Are you a citizen of the European Economic Area (EEA) or Switzerland?"}
          </div>
          <div className="grid md:grid-cols-2 gap-2 w-full mt-4">
            <SegmentedRadioButton
              activeColor={client?.branding?.primaryColor || "#0A71C7"}
              name="eu_citizenship"
              id="eu_citizen"
              value="eu_citizen"
              selectedValue={selectedEUCitizenShip}
              onChange={(e) => {
                resetStates && resetStates();
                setSelectedEUCitizenShip(e.target.value as "eu_citizen");
                dispatch(clearIdDocs());
                dispatch(clearNonIdDocs());
              }}
            >
              Yes, I am
            </SegmentedRadioButton>
            <SegmentedRadioButton
              name="eu_citizenship"
              value="not_eu_citizen"
              id="not_eu_citizen"
              activeColor={client?.branding?.primaryColor || "#0A71C7"}
              selectedValue={selectedEUCitizenShip}
              onChange={(e) => {
                resetStates && resetStates();
                setSelectedEUCitizenShip(e.target.value as "not_eu_citizen");
                dispatch(clearIdDocs());
                dispatch(clearNonIdDocs());
              }}
            >
              No, I am not
            </SegmentedRadioButton>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EUCitizenShip;